'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "makeZoneFile", {
  enumerable: true,
  get: function () {
    return _makeZoneFile.makeZoneFile;
  }
});
Object.defineProperty(exports, "parseZoneFile", {
  enumerable: true,
  get: function () {
    return _parseZoneFile.parseZoneFile;
  }
});
Object.defineProperty(exports, "ZoneFile", {
  enumerable: true,
  get: function () {
    return _zoneFile.ZoneFile;
  }
});

var _makeZoneFile = require("./makeZoneFile");

var _parseZoneFile = require("./parseZoneFile");

var _zoneFile = require("./zoneFile");


//////////////////
// WEBPACK FOOTER
// ./node_modules/zone-file/lib/index.js
// module id = dUjK
// module chunks = 6